module.exports = __webpack_public_path__ + "img/connection-4.f6d76e02.svg";